module.exports = {

    init: function () {
        
        // console.log('GoToTop is working...');

        var initialHeader = jQuery("#header-wrapper").outerHeight();

        jQuery(window).scroll(function () {
            initialHeader = jQuery("#header-wrapper").outerHeight();
            
            if (jQuery(this).scrollTop() > initialHeader) {
                jQuery("#scroll-to-top").fadeIn();
            } else if ( jQuery(this).scrollTop() == 0 ) {
                jQuery("#scroll-to-top").fadeOut();
            }
        });

        jQuery(document).on('click', '#scroll-to-top', function() {
            jQuery("html, body").animate({ scrollTop: 0 }, 500);
        });
        
    }

};